import { Directive } from '@angular/core';

@Directive({
  selector: '[y42FilterableListSummaryItem]',
})
export class FilterableListSummaryItemDirective {}
